import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DropdownComponent from "../../../containers/Dropdown";
import {
  RETURNTOWORK,
  workHasEmployeeReturned,
  ALERT_ERROR_MESSAGE,
  workHasEmployeeReturned_FRENCH,
} from "../../../App.config";
import { date, formatDate } from "../../../utilities/utils";
import DisplayEmployeeBlock from "../DisplayEmployeeBlock";
import ToggleComponent from "../../../containers/Common/ToggleComponent";
import Wheelchair from "../../../images/wheelchair.svg";
import heart from "../../../images/heart.svg";
import AlertError from "../../../containers/Common/AlertError";
import backArrow from "../../../images/back-arrow.svg";
import moment from "moment";
import CustomDatePicker from "../../../containers/Common/CustomDatePicker";

const AbsenceDetails = ({
  onDateChange,
  state,
  handleChanges,
  onSubmit,
  previousStep,
  onDropDownChange,
  props,
  isFormValid,
}) => {
  const chooseDrpLang = () => {
    let defaultLang = workHasEmployeeReturned;
    if (props.i18nReducerLang === "en-US") {
      defaultLang = workHasEmployeeReturned;
    } else {
      defaultLang = workHasEmployeeReturned_FRENCH;
    }

    return defaultLang;
  };

  return (
    <>
      {/* {!isFormValid && <AlertError message={ALERT_ERROR_MESSAGE} />} */}
      <div className="Dashboard-Content">
        <div className="Inner-cell">
          <div className="Panel-cell">
            <div className="Panel-header">
              <img
                tabIndex="-1"
                className="btn btn-back"
                onClick={previousStep}
                src={backArrow}
                alt="back-arrow"
              />
              <div className="p-img">
                <img src={heart} alt="" />
              </div>
              <h2>
                <span>
                  {props.context.t("STD-Employer-Statement.form.heading.text")}
                </span>
                {/* <legend>
                  {props.context.t(
                    "STD-Employer-Statement.form.subheading.text"
                  )}
                  <em>
                    {props.context.t(
                      "STD-Employer-Statement.form.subheading2.text"
                    )}
                  </em>
                </legend> */}
              </h2>
            </div>
            <div className="panel-content">
              <DisplayEmployeeBlock context={props.context} state={state} />
              <div className="Custom-form">
                <h2 className="Sub-Heading">
                  <span>
                    {props.context.t(
                      "STD-Employer-Statement.form.Absence-Details.label.text.Absence-Details"
                    )}
                  </span>
                </h2>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group Date-feild">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Absence-Details.label.text.Last-Day-Worked"
                        )}
                        {props.context.t("AIR-Employer-Information.form.common.DateFormat")}
                      </label>
                      <CustomDatePicker
                        maxDate={moment().toDate()}
                        id="lastDayWorked"
                        selected={state.lastDayWorked.value}
                        onChange={(e) => {
                          onDateChange(e, "lastDayWorked");
                        }}
                        placeholderText={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.calender.PlaceHolder.Common.DatePicker"
                        )}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group Date-feild">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Absence-Details.label.text.First-Day-Absent"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                        {props.context.t("AIR-Employer-Information.form.common.DateFormat")}
                      </label>
                      <CustomDatePicker
                        id="firstDayAbsent"
                        selected={state.firstDayAbsent ? state.firstDayAbsent.value : null}
                        onChange={(e) => {
                          onDateChange(e, "firstDayAbsent");
                        }}
                        placeholderText={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.calender.PlaceHolder.Common.DatePicker"
                        )}
                        ref={state.firstDayAbsent.ref}
                        className="form-control"
                        yearDropdown={5}
                      />
                      {state.firstDayAbsent?.error && (
                        <span className="error">
                          {state.firstDayAbsent.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.text.Ques1"
                        )}
                      </label>
                      <ToggleComponent
                        name="enableReturnToWork"
                        isActive={state.enableReturnToWork.value}
                        negativeValueTobeCompare="No"
                        positiveValueTobeCompare="Yes"
                        handleChanges={handleChanges}
                        positiveValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                        )}
                        negativeValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                        )}
                      />
                    </div>
                  </div>
                  {state.enableReturnToWork.value === "Yes" ? (
                    <>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-4 input-group">
                        <div className="form-group Date-feild">
                          <label htmlFor="dateReturnToWork">
                            {props.context.t(
                              "STD-Employer-Statement.form.Absence-Details.label.text.Date-Of-Rtw"
                            )}
                            <span size="5" className="error-star">
                              *
                            </span>
                            {props.context.t("AIR-Employer-Information.form.common.DateFormat")}
                          </label>
                          <CustomDatePicker
                            selected={
                              state.enableReturnToWork.value
                                ? state.returnToWork.value
                                : ""
                            }
                            onChange={(e) => {
                              onDateChange(e, "returnToWork");
                            }}
                            placeholderText={props.context.t(
                              "STD-Employer-Statement.form.Absence-Details.label.text.Date-Of-Rtw"
                            )}
                            ref={state.returnToWork.ref}
                            className="form-control"
                            id="dateReturnToWork"
                          />
                          {state.returnToWork?.error && (
                            <span className="error">
                              {state.returnToWork.error}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-4 form-group">
                        <label htmlFor="">
                          {props.context.t(
                            "STD-Employer-Statement.form.Absence-Details.label.text.Type-Of-Rtw"
                          )}
                          <span size="5" className="error-star">
                            *
                          </span>
                        </label>
                        <DropdownComponent
                          name="typeOfWork"
                          id="typeOfWork"
                          options={chooseDrpLang()}
                          isMultiSelect={false}
                          option_key="typeOfWorkId"
                          option_display="typeOfWork"
                          onChange={onDropDownChange}
                          values={state.typeOfWork.value}
                          simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                          selectAllText="Select All Options"
                          isSearchOption={true}
                          searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                          ref={state.typeOfWork.ref}
                        />
                        {state.typeOfWork?.error && (
                          <span className="error">
                            {state.typeOfWork.error}
                          </span>
                        )}
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                        {state.isTypeOfWorkOtherHasSelected.value ? (
                          <div className="form-group">
                            <label htmlFor="" className="one-line">
                              &nbsp;
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder={props.context.t(
                                "STD-Employer-Statement.form.dropdown.PlaceHolder.Common.IfOtherSpecifyHere"
                              )}
                              name="typeOfWorkOther"
                              value={state.typeOfWorkOther.value}
                              onChange={handleChanges}
                            />
                          </div>
                        ) : null}
                      </div>
                    </>
                  ) : null}
                </div>

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.text.Ques2"
                        )}
                      </label>
                      <ToggleComponent
                        name="alteredDuties"
                        isActive={state.alteredDuties.value}
                        negativeValueTobeCompare="No"
                        positiveValueTobeCompare="Yes"
                        positiveValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                        )}
                        negativeValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                        )}
                        handleChanges={handleChanges}
                      />
                    </div>
                    <div>
                      {state.alteredDuties.value === "Yes" ? (
                        <div>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder={props.context.t(
                                "STD-Employer-Statement.form.dropdown.PlaceHolder.Common.IfOtherdescribe"
                              )}
                              name="isAlteredDutiesYes"
                              value={state.isAlteredDutiesYes.value}
                              onChange={handleChanges}
                            />
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group Date-feild">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.text.EDSED"
                        )}
                        {props.context.t("AIR-Employer-Information.form.common.DateFormat")}
                      </label>
                      <CustomDatePicker
                        id="sTDExpiryDate"
                        selected={state.sTDExpiryDate.value}
                        onChange={(e) => {
                          onDateChange(e, "sTDExpiryDate");
                        }}
                        placeholderText={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Calender.PlaceHolder.Common.SelectHere"
                        )}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.text.Ques4"
                        )}
                      </label>
                      <div className="Radio-box" data-toggle="buttons">
                        <div className="check-col">
                          <input
                            type="radio"
                            name="eligibleLTD"
                            id="employee-option1"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="Yes"
                            checked={state.eligibleLTD.value === "Yes"}
                          />
                          <label htmlFor="employee-option1">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="eligibleLTD"
                            id="employee-option2"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="No"
                            checked={state.eligibleLTD.value === "No"}
                          />
                          <label htmlFor="employee-option2">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="eligibleLTD"
                            id="employee-option3"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="NA"
                            checked={state.eligibleLTD.value === "NA"}
                          />
                          <label htmlFor="employee-option3">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.Toggle.Na.Common"
                            )}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Absence-Details.label.text.Ques9"
                        )}
                      </label>
                      <div className="Radio-box" data-toggle="buttons">
                        <div className="check-col">
                          <input
                            type="radio"
                            name="workPlaceAccident"
                            id="employee-option10"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="Yes"
                            checked={state.workPlaceAccident.value === "Yes"}
                          />
                          <label htmlFor="employee-option10">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="workPlaceAccident"
                            id="employee-option11"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="No"
                            checked={state.workPlaceAccident.value === "No"}
                          />
                          <label htmlFor="employee-option11">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="workPlaceAccident"
                            id="employee-option12"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="NA"
                            checked={state.workPlaceAccident.value === "NA"}
                          />
                          <label htmlFor="employee-option12">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.Toggle.Na.Common"
                            )}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Absence-Details.label.text.Ques1"
                        )}
                      </label>
                      <div className="Radio-box" data-toggle="buttons">
                        <div className="check-col">
                          <input
                            type="radio"
                            name="compensationPending"
                            id="employee-option4"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="Yes"
                            checked={state.compensationPending.value === "Yes"}
                          />
                          <label htmlFor="employee-option4">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="compensationPending"
                            id="employee-option5"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="No"
                            checked={state.compensationPending.value === "No"}
                          />
                          <label htmlFor="employee-option5">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="compensationPending"
                            id="employee-option6"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="NA"
                            checked={state.compensationPending.value === "NA"}
                          />
                          <label htmlFor="employee-option6">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.Toggle.Na.Common"
                            )}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Absence-Details.label.text.Ques2"
                        )}
                      </label>
                      <div className="Radio-box" data-toggle="buttons">
                        <div className="check-col">
                          <input
                            type="radio"
                            id="employee-option7"
                            autoComplete="off"
                            name="caseForAutomobileWage"
                            onChange={handleChanges}
                            value="Yes"
                            checked={
                              state.caseForAutomobileWage.value === "Yes"
                            }
                          />
                          <label htmlFor="employee-option7">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            id="employee-option8"
                            autoComplete="off"
                            name="caseForAutomobileWage"
                            onChange={handleChanges}
                            value="No"
                            checked={state.caseForAutomobileWage.value === "No"}
                          />
                          <label htmlFor="employee-option8">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            id="employee-option9"
                            autoComplete="off"
                            name="caseForAutomobileWage"
                            onChange={handleChanges}
                            value="NA"
                            checked={state.caseForAutomobileWage.value === "NA"}
                          />
                          <label htmlFor="employee-option9">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.Toggle.Na.Common"
                            )}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    {/* <div className="panel-footer margn-50">
                      <a
                        tabIndex="0"
                        onClick={previousStep}
                        className="btn btn-primary"
                      >
                        {props.context.t(
                          "STD-Employer-Statement.form.button.previous"
                        )}
                      </a>
                    </div> */}
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="panel-footer text-right margn-50">
                      <a
                        tabIndex="0"
                        onClick={() => onSubmit(false, false)}
                        className="btn btn-blue"
                      >
                        {props.context.t(
                          "AIR-Employer-Information.form.button.save-for-later.title"
                        )}
                      </a>
                      <a
                        tabIndex="0"
                        onClick={onSubmit}
                        className="btn btn-primary margin-left-5"
                      >
                        {props.context.t(
                          "STD-Employer-Statement.form.button.save-and-move-next-step.title"
                        )}
                      </a>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AbsenceDetails;
